const HIGHWAY_CONFIG = {
  OPEN: {
    key: "open",
    label: "Open",
    labelNe: "खुला",
    color: "#78E08F",
    status: "OPEN",
  },
  PARTIAL: {
    key: "partialOpen",
    label: "Partially Open",
    labelNe: "आंशिक रूपमा अवरुद्ध",
    color: "#E0D478",
    status: "PARTIAL_OPEN",
  },
  CLOSED: {
    key: "closed",
    label: "Closed",
    labelNe: "अवरुद्ध",
    color: "#E07878",
    status: "CLOSED",
  },
} as const;

const HIGHWAY_CHART = {
  TITLE: "Highway Status Statistics",
  STACK_ID: "status",
};

const DEFAULT_STACKED_BARS = Object.values(HIGHWAY_CONFIG).map(
  ({ key, color }) => ({
    dataKey: key,
    stackId: HIGHWAY_CHART.STACK_ID,
    fill: color,
  })
);

const DEFAULT_LEGEND_DATA = Object.values(HIGHWAY_CONFIG).map(
  ({ label, color }, index) => ({
    id: index + 1,
    label,
    fill: color,
  })
);

export {
  HIGHWAY_CONFIG,
  HIGHWAY_CHART,
  DEFAULT_STACKED_BARS,
  DEFAULT_LEGEND_DATA,
};
